
define('text!modules/strategy/supply/shared/templates/bin_group_item.html',[],function () { return '<div class="column segment">\n\t<div class="item-c text" title="{{name}}">{{{truncated}}}</div>\n</div>\n{{#price}}\n\t<div class="column size">\n\t\t<span class="item-c text">{{#asCurrency}}{{price}}{{/asCurrency}}&nbsp;{{price_type}}</span>\n\t</div>\n{{/price}}\n';});

